import { Hidden, IconButton, useMediaQuery, useTheme } from "@mui/material";
import { Avatar } from "@mui/material";
import { IPeople } from "../../redux/reducers/people.reducer";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/system";
import { makeStyles } from "@mui/styles";

type propsType = {
  assignedEmployee: IPeople[];
};

export default function SidebarCalendar(props: propsType) {
  const { assignedEmployee } = props;
  const theme = useTheme();
  const isSmallerSize = useMediaQuery(theme.breakpoints.down("lg"));

  const useStyles = makeStyles(() => ({
    sidebarContainer: {
      height: "75vh",
      [theme.breakpoints.down("lg")]: {
        height: "100%",
        minHeight: "100px",
        maxHeight: "0",
      },
    },
  }));
  const classes = useStyles();

  // const settings = useSelector(
  //   (state: storeStateType) => state.sitesetting.settings
  // );

  // const colorSetting = settings?.filter(
  //   (setting) => setting.config_name === "app"
  // );
  const navigate = useNavigate();
  function renderEmployeeProfiles() {
    return assignedEmployee.map((employee: IPeople) => {
      return (
        <Box
          key={employee.id}
          display="flex"
          alignItems="center"
          padding="0.5rem"
          onClick={() => {
            navigate(`../employee/profile/${employee.id}`);
          }}
          sx={{ cursor: "pointer" }}
        >
          <IconButton key={employee.id} sx={{ p: 0, m: 0.5 }}>
            <Avatar
              title={employee.fullname}
              sx={{ height: "20px", width: "20px", fontSize: "12px" }}
              alt={employee.fullname}
              src={employee.avatar ?? "null"}
            />
          </IconButton>
          <Hidden lgDown>
            <Typography variant="body1" ml="10px" fontSize={14}>
              {employee?.fullname}
            </Typography>
          </Hidden>
        </Box>
      );
    });
  }

  return (
    <Box
      className={classes.sidebarContainer}
      sx={{
        overflowY: "scroll",
        overflowX: "hidden",
        backgroundColor: "background.paper",
      }}
    >
      <Typography variant="subtitle1" padding={"0.4rem 0"} fontWeight={600}>
        {"Employee"}
      </Typography>
      <Box
        className="employee-container"
        display="flex"
        flexWrap="wrap"
        flexDirection={isSmallerSize ? "row" : "column"}
      >
        {renderEmployeeProfiles()}
      </Box>
    </Box>
  );
}
